<script>
import { mapActions } from 'vuex';

import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Volunteer Types'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Volunteer Types'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name' },
                {
                    text: 'Language',
                    value: 'language.code',
                    type: 'enum',
                    isLanguage: true,
                    enumOptions: [
                        { value: 'he', label: 'Hebrew' },
                        { value: 'en', label: 'English' },
                        { value: 'ar', label: 'Arabic' },
                        { value: 'ru', label: 'Russian' }
                    ]
                },
                {
                    value: 'date',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'volunteerTypes/index',
            deleteItem: 'volunteerTypes/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/volunteer-types/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/volunteer-types/add');
        }
    }
};
</script>
